import React from 'react';
import { X, AlertTriangle, Loader2 } from 'lucide-react';

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Konfirmasi Hapus',
  message = 'Apakah Anda yakin ingin menghapus item ini? Tindakan ini tidak dapat dibatalkan.',
  isConfirming = false,
  targetName = 'item ini', // Added for more specific messaging
}) => {
  if (!isOpen) return null;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000 // Ensure it's above other modals
    },
    modal: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '1rem',
      width: '90%',
      maxWidth: '400px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1rem'
    },
    titleText: {
      fontSize: '1.25rem',
      fontWeight: '700',
      color: '#111',
      flexGrow: 1, // Make title take available space
      textAlign: 'center', // Center title
    },
    closeButton: {
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      color: '#6b7280'
    },
    iconContainer: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      backgroundColor: '#fee2e2',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem auto' // Center and add margin
    },
    messageText: {
      margin: 0,
      color: '#6b7280',
      fontSize: '0.9rem'
    },
    actions: {
      display: 'flex',
      justifyContent: 'center',
      gap: '1rem',
      marginTop: '1.5rem'
    },
    cancelBtn: {
      backgroundColor: '#f3f4f6',
      color: '#374151',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      border: 'none',
      cursor: 'pointer',
      fontWeight: '600',
      transition: 'background-color 0.2s'
    },
    dangerBtn: {
      backgroundColor: '#dc2626',
      color: '#fff',
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      border: 'none',
      cursor: 'pointer',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      transition: 'background-color 0.2s',
      opacity: isConfirming ? 0.7 : 1
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={{...styles.header, marginBottom: '0.5rem'}}> {/* Adjust margin for header */}
          <div style={{flexGrow: 1}}></div> {/* Placeholder for left align */}
          <h3 style={styles.titleText}>{title}</h3>
          <button onClick={onClose} style={styles.closeButton}>
            <X size={20} />
          </button>
        </div>
        
        <div style={styles.iconContainer}>
          <AlertTriangle color="#dc2626" size={24} />
        </div>
        <p style={styles.messageText}>
          {message.replace('item ini', targetName)}
        </p>
        
        <div style={styles.actions}>
          <button onClick={onClose} style={styles.cancelBtn}>
            Batal
          </button>
          <button onClick={onConfirm} style={styles.dangerBtn} disabled={isConfirming}>
            {isConfirming ? <Loader2 className="animate-spin" size={18} /> : 'Hapus Permanen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
